<template>
  <div>
    <memberinfo v-if="user_id != ''" class="member-container" :project_id="project_id"
                :user_id.sync="user_id"></memberinfo>
    <div class="manequipment-container">
      <div class="manequipment-container-left">
        <div class="manequipment_item">
          <totalequipment :project_id="project_id"></totalequipment>
        </div>
        <div class="manequipment_item">
          <div v-if="dataNotNull" key="1" class="expiredDiv" style="width: 100%; height: 100%">
            <div class="container1" style="margin:15px 0 0 20px; height: 100%;"></div>
          </div>
          <div v-else key="2" style="width: 100%; height: 100%;">
            <div class="title_nationality">{{ expired_title }}
            </div>
            <div class="zero_nationality">No Data !</div>
          </div>
        </div>
      </div>
      <div class="manequipment-container-right">
        <div class="has-border">
          <div class="member_title">Project Equipment</div>
          <div class="member_project" style="display: flex;flex-direction: column; text-align: left; width: 300px">
            <el-select v-model="default_company" placeholder="select contractor" popper-class="optionsContent"
                       @change="switch_company">
              <el-option
                v-for="item in multi_companies"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="member_container_item">
            <div class="member_container_item_one item_big">S/N</div>
            <div class="member_container_item_two item_big">Name</div>
            <div class="member_container_item_two item_big">Type</div>
            <div class="member_container_item_two item_big">Registration No.</div>
            <div class="member_container_item_two item_big">In</div>
            <div class="member_container_item_two item_big">Out</div>
            <div class="member_container_item_two item_big">Status</div>
          </div>
          <div class="member_container_item_container">
            <div style="width: 100%; margin-top: 18px; display: flex; align-items: center; text-align: center"
                 v-for="(item, index) in members[company_index]" :key="'member_' + index">
              <div class="member_container_item_one_special">{{ index + 1 }}</div>
              <div class="member_container_item_two_special">{{ item.device_name }}</div>
              <div class="member_container_item_two_special">{{ item.device_type_en }}</div>
              <div class="member_container_item_two_special">{{ item.device_id }}</div>
              <div class="member_container_item_two_special">{{
                  item.in_time ? item.in_time.substring(0, 10) : '-'
                }}
              </div>
              <div class="member_container_item_two_special">{{
                  item.out_time ? item.out_time.substring(0, 10) : '-'
                }}
              </div>
              <div class="member_container_item_two_special">{{ item.out_time == '' ? 'Active' : 'Inactive' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="manpower_detail" v-show="showflag" id="manpower_detail">
      <div class="close_img_manequipment" @click="detailClose"></div>
      <div class="manpowerDiv1"
           style="width: 100%; height: 100%; display: flex; flex-direction: column">
        <div class="manpower_detail_title">Workers</div>
        <div class="container1"></div>
        <div class="manpower_detail_title">Staff</div>
        <div class="container2"></div>
      </div>
    </div>

    <div class="expired_detail" v-show="showflag1" id="expired_detail">
      <div class="expiredDiv1"
           style="width: 100%; height: 100%; display: flex; flex-direction: column">
        <h1
          style="height: 30px; color: white; font-weight: bold; font-size: 16px; line-height: 30px; padding-left: 20px; text-align: center">
          <div class="select manequip h_big"
               style="z-index: 9;width: 80%;display: inline-block;font-size: 28px">
            <el-select v-model="default_tag"
                       placeholder="请选择" popper-class="optionsContent"
                       @change="switch_tag">
              <el-option
                v-for="item in multi_tags"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </h1>
        <div class="close_img_expired" @click="detail1Close"></div>
        <div class="ptwDiv1"
             style="width: 100%; height: 400px; display: flex; flex-direction: column; overflow: scroll">
          <div style="width: 100%; height: 40px; display: flex">
            <div class="equip_expired_item_one">S/N</div>
            <div class="equip_expired_item_one equip_item_two">Name</div>
            <div class="equip_expired_item_one equip_item_two">Type</div>
            <div class="equip_expired_item_one equip_item_two">Registration No.</div>
            <div class="equip_expired_item_one equip_item_two">Expired</div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; margin-top: 18px"
               v-for="(item, index) in expired_datas"
               :key="'expired_' + index">
            <div class="equip_expired_item_one">{{ index + 1 }}</div>
            <div class="equip_expired_item_one equip_item_two">{{ item.device_name }}</div>
            <div class="equip_expired_item_one equip_item_two">{{ item.device_type_en }}</div>
            <div class="equip_expired_item_one equip_item_two">{{ item.device_id }}</div>
            <div class="equip_expired_item_one equip_item_two">{{ item.permit_enddate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import echarts from "echarts";
import totalequipment from "@/components/manpower/totalequipment";

export default {
  name: "manequipment",
  props: ['project_id'],

  data() {
    return {
      user_id: '',
      color: this.$store.state.color.chart_color,
      manHours: 'No Data !',
      manDays: 'No Data !',
      showflag: false,
      showflag1: false,
      myChart: null,
      expired_title: 'Equipment Certificate',
      dataNotNull: true,
      default_tag: "Expired",
      multi_tags: [
        {label: "Expired", value: "0"},
        {label: "3-month Expiry", value: "1"},
        {label: "6-month Expiry", value: "2"},
      ],
      expire_datas: [],
      three_month_datas: [],
      six_month_datas: [],
      default_company: "",
      company_index: 0,
      multi_companies: [],
      members: [],
      expired_datas: []
    }
  },
  components: {
    totalequipment
  },

  methods: {
    showDetail() {
      var that = this
      this.showflag = true

    },
    detailClose() {
      this.showflag = false
    },
    detail1Close() {
      this.showflag1 = false
    },
    switch_tag(label) {
      var that = this
      if (label == '0') {
        that.expired_datas = that.expire_datas
      } else if (label == '1') {
        that.expired_datas = that.three_month_datas
      } else { //6-month Expired
        that.expired_datas = that.six_month_datas
      }
    },
    switch_company(label) {
      this.company_index = label
    },
    showExpired(name) {
      var that = this
      if (name == 'Expired') {
        that.expired_datas = that.expire_datas
      } else if (name == '3-month Expiry') {
        that.expired_datas = that.three_month_datas
      } else { //6-month Expired
        that.expired_datas = that.six_month_datas
      }
      that.showflag1 = true
    },
    getExpired() {
      var that = this
      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      }
      axios.post(this.$store.getters.getCmsServer + "DBEquipments", postData).then(resp => {    //生产
        this.myChart.hideLoading()
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          this.dataNotNull = true
          var result = resp.data.result;
          that.analysisEquips(result)
          that.analysisCompanies(result)
        } else {
          console.log(errStr)
          alert(errStr)
          this.dataNotNull = false
        }
      }).catch(error => {
        console.log(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
        alert(error)
      })
    },
    analysisEquips(data) {
      var that = this
      var now = this.getNowDate()
      var three_month = this.getEndDate(3)
      var six_month = this.getEndDate(6)
      data.forEach((item, index) => {
        var expired = item.permit_enddate
        if (expired < now) {
          this.expire_datas.push(item)
        } else if (expired < three_month) {
          this.three_month_datas.push(item)
        } else if (expired < six_month) {
          this.six_month_datas.push(item)
        }
      })
      this.myChart.setOption({
        series: [
          {
            data: [that.expire_datas.length, that.six_month_datas.length, that.three_month_datas.length]
          }
        ]
      })
    },
    analysisCompanies(data) {
      var that = this
      var ids = []
      var com_ids = []
      var coms = []
      var datas = []
      that.multi_companies = []
      that.members = []
      data.forEach((item, index) => {
        var id = item.primary_id
        var index = ids.indexOf(id)
        if (index < 0) {
          datas.push(item)
        }
      })
      datas.forEach((item, index) => {
        var com_id = item.contractor_id
        var index = com_ids.indexOf(com_id)
        if (index < 0) {
          var length = that.multi_companies.length
          that.multi_companies.push({
            label: item.contractor_short_name,
            value: length
          })
          com_ids.push(com_id)
          that.members.push([item])
        } else {
          that.members[index].push(item)
        }
      })
      that.company_index = 0
      if (data.length > 0) {
        that.default_company = that.multi_companies[0].label
      }
    },
    getNowDate() {
      var nowDate = new Date()
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
      var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "-" + month + "-" + day;
      return dateStr
    },
    getEndDate(month) {
      var nowDate = new Date()
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + parseInt(month)
      if (month > 12) {
        month -= 12
        year += 1
      }
      month = month < 10 ? "0" + month : month
      var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "-" + month + "-" + day;
      return dateStr
    }
  },

  mounted() {
    var that = this

    this.myChart = echarts.init(document.querySelector('.expiredDiv .container1'))
    this.myChart.setOption({
      title: {
        text: that.expired_title,
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      grid: {
        left: 0
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        textStyle: {
          fontSize: '16'
        }
      },
      xAxis: {
        type: 'category',
        inverse: true,
        data: ['Expired', '6-month Expiry', '3-month Expiry'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          width: '100%',
          interval: 0,
          textStyle: {
            color: '#FFF',
            fontSize: 14
          },
          formatter: function (params) {
            var newParamsName = "";
            var paramsplit = params.split(' ')
            paramsplit.forEach((param, index) => {
              if (index == 0) {
                newParamsName += param
              } else {
                newParamsName += "\n";
                newParamsName += param
              }
            })
            return newParamsName
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        // axisLabel: {
        //   formatter: '{value}'
        // },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          type: 'bar',
          barWidth: '40%',
          data: [],
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              },
            }
          },
        }
      ]
    })

    this.myChart.on('click', function (param) {
      that.showExpired(param.name)
    });

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
    this.getExpired()
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

.manequipment-container {
  margin: 0;
  padding: 0;
  color: #FFF
  position: relative;
  width: 100%
  height: 100%
  overflow: hidden
  display flex
}

.manequipment-container-left {
  width 25%
  height 100%
  /*background-color #7e8bad*/
  display flex
  flex-direction column
}

.manequipment-container-right {
  width 75%
  height 100%
  /*background-color #7e8bad*/
  display flex
  flex-direction column
  z-index 99
}

.has-border {
  width 97%
  height 97%
  overflow scroll
  margin 1%
  border 1px solid #333
  display flex
  flex-direction column
}

.member_title {
  width 90%
  height 30px
  line-height 30px
  font-size 16px
  margin-left 16px
  color white
  text-align left
}

.member_project .el-input__inner {
  font-size 16px
  color #66CCFF
  width: 300px;
  height: 40px;
  line-height 40px;
  background-color transparent
  border none
}

.el-select .el-input .el-select__caret {
  display none
}

.member_container_item {
  width 100%
  height 40px
  margin-top 5px
  display flex
  text-align center
}

.member_container_item_one {
  width 10%;
  height 30px
  line-height 30px
  font-size 14px
}

.member_container_item_two {
  width 15%;
  height 30px
  line-height 30px
  font-size 14px
}

.member_container_item_one_special {
  width 10%;
  line-height 22px
  font-size 14px
}

.member_container_item_two_special {
  width 15%;
  line-height 22px
  font-size 14px
  word-break: break-all
}

.member_container_item_container {
  width: 100%;
  height: 520px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  overflow: scroll
}

.item_big {
  font-size 18px
  margin-top 20px
}

.manequipment-container-left-one {
  width 100%
  height 32%
  display flex
  margin-top: 1%
}

.manequipment_item {
  background-color #31334a
  font-size 1em
  text-align: center;
  width 92%
  margin: 2% 2% 0 2%;
  height 32%
}

.item_outer {
  display flex
  flex-wrap wrap
  font-size 16px
}

.item_outer_title {
  width 100%
  height 30px
  font-size 16px
  line-height 30px
  text-align left
  margin-left 10px
}

.item_outer_item {
  width 50%
  height 120px
}

.item_outer_item_count {
  font-size 48px
  width 100%
  height 60px
  line-height 60px
  overflow: hidden;
  /*display: -webkit-box;*/
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.item_outer_item_type {
  font-size 24px
  height 40px
  line-height 40px
}

.member-container {
  position: relative;
  width: 100%
  height: 100%
}

.title_manhours
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.content_manhours
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF

.title_mandays
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.content_mandays
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF

.manpower_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 60%;
  height: 90%;
  left: 20%;
  top: 4%;
  text-align: left;
  font-size: 40px;
  z-index: 99;
  color #333333
}

.expired_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 60%;
  height: 70%;
  left: 20%;
  top: 12%;
  text-align: left;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.equip_expired_item_one {
  width 12%;
  //min-height 40px
  line-height 22px
  /*font-weight bold*/
  font-size 22px
  text-align center
}

.equip_item_two {
  width 22%
  font-size 18px
}

.certs_container {
  width 95%
  //height 100px
  max-height 200px
  overflow scroll
  border 1px solid red
  display flex
  flex-direction column
  margin-top 20px
  margin-left 1%
}

.certs_title {
  height 30px
  line-height 30px
  margin-left 5px
  font-weight bold
  font-size 18px
}

.cert_item {
  width 90%
  height 30px
  line-height 30px
  margin-left 10px
  font-weight bold
  font-size 18px
  //overflow hidden
}

.manpower_detail_title {
  height 5%
  margin-left 10px
  font-size 18px
  text-align left
  font-weight bold
  color #333
}

.close_img_manequipment {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
  z-index 9
}

.container1, .container2 {
  width 100%
  height 44%
}

.title_expired {
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px
}

.zero_expired {
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
}

.h_big .el-input__inner {
  font-size 30px
}

.expired_content {
  width 100%
  max-height 400px
  overflow scroll
  display flex
  flex-direction column
  text-align center
}

.el-collapse-item__header {
  font-size 20px
  height 30px
  line-height 30px
  display inline
  margin-left 20px
  background-color rgb(248, 248, 248)
}

.close_img_expired {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
}

.company_select .el-input__inner {
  background-color #cccccc
}
</style>



// WEBPACK FOOTER //
// src/components/manpower/manequipment.vue